<template>
	<div class="app">
		<van-row type="flex" justify="center">
			<van-col span="24" align="center">
				<router-view />
			</van-col>
		</van-row>
		<TabBar v-if="showTabBar" />
	</div>
</template>

<script>
import TabBar from '@/components/tabbar'
// @ is an alias to /src
export default {
	name: 'HomeView',
	components: {
		TabBar
	},
	computed: {
		showTabBar() {
			return ['/home', '/menu', '/me'].includes(this.$route.path)
		}
	},
	data() {
		return {}
	}
}
</script>

<style lang="less">
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	word-break: keep-all;
	-webkit-tap-highlight-color: transparent;
	// font-weight: 400;
}
body,
html {
	background-color: #fafafa;
	font-size: 16px;
	line-height: 20px;
}
</style>
